import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { StylesProvider } from '@mui/styles';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { ptBR } from '@mui/material/locale';

import getHistory from '@giro/shared-utils/getHistory.util';

import themeConstants from '@giro/shared-constants/theme.constant';

import { useStore } from '@giro-pdv-terminal-whitelabel/store';

import reportWebVitals from './reportWebVitals';

import Routes from './routes';

import './index.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-simple-keyboard/build/css/index.css';

const PALETTE_PRIMARY = {
  main: '#82D1F4',
  light: '#9bdaf6',
  dark: '#5b92aa',
};

const PALLET_SECONDARY = {
  main: '#C8CF4B',
  light: '#d3d86f',
  dark: '#8c9034',
};

const App = () => {
  const store = useStore();
  const theme = createTheme(
    {
      ...({
        ...themeConstants,
        palette: {
          ...themeConstants.palette,
          primary: PALETTE_PRIMARY,
          secondary: PALLET_SECONDARY,
        },
      } as any),
    },
    ptBR
  );

  return (
    <Provider store={store}>
      <StylesProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          <SnackbarProvider>
            <Router history={getHistory()}>
              <Routes />
            </Router>
          </SnackbarProvider>
        </ThemeProvider>
      </StylesProvider>
    </Provider>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
